/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PrepaidInputs */

const cs_enum_prepaid = /** @type {(inputs: Enum_PrepaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předplatné`)
};

const en_enum_prepaid = /** @type {(inputs: Enum_PrepaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepaid`)
};

/**
* | output |
* | --- |
* | "Prepaid" |
*
* @param {Enum_PrepaidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_prepaid = /** @type {((inputs?: Enum_PrepaidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PrepaidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_prepaid(inputs)
	return cs_enum_prepaid(inputs)
});